module.exports = __webpack_public_path__ + "files/c42340e7604fe9b249e41a9677ac4e1c.png";